import React from "react";
import CustomIcon from "../CustomIcon";
import {CONTACT} from "../../__constants__";

const FirmHelpPanel = () => {
    return (
      <div className='p-10 items-center bg-pale-mint-green w-[calc(100%+8px)] -m-1 flex flex-wrap box-border '>
        <div className='p-1 grow-0 max-w-[50%] basis-[50%] m-0 box-border max-sm:max-w-full max-sm:basis-full '>
          <div className='flex flex-col'>
            <h4 className='font-bold mb-3 text-[2.125rem] leading-[1.235] m-0 max-sm:text-center'>
              Need help?
            </h4>
            <p className='text-xl font-bold leading-[1.5] m-0 '>
              Let our team find the right firm for you
            </p>
          </div>
        </div>

        <div className='flex justify-between items-center font-bold max-xs:block m-0 grow-0 max-w-[50%] basis-[50%] max-sm:max-w-full max-sm:basis-full '>
          <div className='flex max-xs:justify-center'>
            <div>
              <h5 className='flex text-2xl leading-[1.334] m-0'>
                <CustomIcon icon="phone" color="navt" />
              </h5>
            </div>
            <div className='font-bold'>
              <h5 className='flex text-2xl leading-[1.334] m-0'>
                {CONTACT.ACCOUNTS_TEAM_NUMBER}
              </h5>
              <p className='text-[1.1rem] leading-[1.5] m-0'>
                Free to call, no obligation
              </p>
              <p className='text-[1.1rem] leading-[1.5] m-0'>
                100% impartial service
              </p>
            </div>
          </div>
        </div>
      </div>
    );
};

export default FirmHelpPanel;
